import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nfts: {},
};

export const NFTSlice = createSlice({
  name: "nft",
  initialState,
  reducers: {
    updateNFTStore: (state, action) => {
      if (action.payload?.token_id) {
        const existing = state.nfts[action.payload.token_id] || {};
        
        // 🚀 FIX: Deep merge rentals.rentals array to properly update reservation status
        let mergedRentals = action.payload.rentals;
        if (existing.rentals?.rentals && action.payload.rentals?.rentals) {
          // Create a map of existing reservations by their unique key
          const existingReservationsMap = new Map();
          existing.rentals.rentals.forEach(r => {
            if (r.renting_period && r.address) {
              const key = `${r.address}-${r.renting_period[0]}-${r.renting_period[1]}`;
              existingReservationsMap.set(key, r);
            }
          });
          
          // Merge: use new reservation data (from backend) which has latest status
          // But preserve any local state if needed
          mergedRentals = {
            ...action.payload.rentals,
            rentals: action.payload.rentals.rentals.map(newReservation => {
              if (newReservation.renting_period && newReservation.address) {
                const key = `${newReservation.address}-${newReservation.renting_period[0]}-${newReservation.renting_period[1]}`;
                const existingReservation = existingReservationsMap.get(key);
                
                // Always use new reservation data from backend (it has latest status)
                // Backend is source of truth after confirmReservationAction
                return newReservation;
              }
              return newReservation;
            })
          };
        }
        
        state.nfts[action.payload.token_id] = {
          ...existing,
          ...action.payload,
          // Ensure rentals is properly set with merged data
          rentals: mergedRentals || action.payload.rentals || existing.rentals,
        };
      }
    },
    bulkUpsertNFTs: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      action.payload.forEach((item) => {
        if (!item?.token_id) return;
        const existing = state.nfts[item.token_id] || {};
        
        // 🚀 FIX: Deep merge rentals.rentals array to preserve updated reservation data
        // If existing has newer reservation data (with approved: true), don't overwrite it
        let mergedRentals = item.rentals;
        if (existing.rentals?.rentals && item.rentals?.rentals) {
          // Create a map of existing reservations by their unique key
          const existingReservationsMap = new Map();
          existing.rentals.rentals.forEach(r => {
            if (r.renting_period && r.address) {
              const key = `${r.address}-${r.renting_period[0]}-${r.renting_period[1]}`;
              existingReservationsMap.set(key, r);
            }
          });
          
          // Merge: use existing reservation if it's newer (has approved: true and new item doesn't)
          // Otherwise use the new item's reservation
          mergedRentals = {
            ...item.rentals,
            rentals: item.rentals.rentals.map(newReservation => {
              if (newReservation.renting_period && newReservation.address) {
                const key = `${newReservation.address}-${newReservation.renting_period[0]}-${newReservation.renting_period[1]}`;
                const existingReservation = existingReservationsMap.get(key);
                
                // If existing reservation is approved and new one isn't, keep the existing one
                if (existingReservation?.approved && !newReservation.approved) {
                  console.log(`🔄 [REDUX] Preserving approved reservation from existing state:`, {
                    token_id: item.token_id,
                    traveler: newReservation.address,
                    period: newReservation.renting_period,
                  });
                  return existingReservation;
                }
              }
              return newReservation;
            })
          };
        }
        
        state.nfts[item.token_id] = {
          ...existing,
          ...item,
          rentals: mergedRentals || item.rentals || existing.rentals,
        };
      });
    },
    // Add this new action
    clearNFTDetails: (state) => {
      // Clear any specific NFT details that might be causing issues
      // Keep the main NFT list but clear any detailed views
      Object.keys(state.nfts).forEach(tokenId => {
        if (state.nfts[tokenId].detailsLoaded) {
          delete state.nfts[tokenId].detailsLoaded;
        }
      });
    },
    // Add this to completely reset NFT state if needed
    resetNFTState: () => initialState,
  },
});

export const { updateNFTStore, bulkUpsertNFTs, clearNFTDetails, resetNFTState } =
  NFTSlice.actions;

export default NFTSlice.reducer;
